// Generated by Melange

import * as Buhta_cabinet__Box from "../../components/html/Box.js";
import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_cabinet__RadioButton from "../../components/html/RadioButton.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__Select from "../../components/html/Select.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_components__ToastContainer from "../../../../../packages/components/src/moleculas/ToastContainer.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function secondsToTime(seconds) {
  const mask = function (n) {
    if (n < 10) {
      return "0" + String(n);
    } else {
      return String(n);
    }
  };
  const minutes = mask(seconds / 60 | 0);
  const seconds$1 = mask(seconds % 60);
  return "" + minutes + ":" + seconds$1;
}

function ObsoleteRegisterForm$AddBinStage(Props) {
  let onBinAdded = Props.onBinAdded;
  const initialFocusRef = React.useRef(null);
  return JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
    onSubmit: (function (param) {
      
    }),
    initialFocusRef: initialFocusRef,
    className: "mt-10",
    children: [
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "Введите БИН/ИИН",
        type_: "number",
        inputRef: initialFocusRef,
        value: ""
      }),
      JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
        className: "mt-1 text-gray-medium",
        children: "БИН состоит из 12 цифр. Например: 901226300074"
      }),
      JsxRuntime.jsx(Buhta_cabinet__Button.make, {
        kind: "primary",
        type_: "submit",
        className: "mt-6",
        isWide: true,
        onClick: (function (param) {
          Curry._1(onBinAdded, undefined);
        }),
        children: "Продолжить"
      }),
      JsxRuntime.jsx(Buhta_cabinet__Button.make, {
        kind: "default",
        type_: "button",
        className: "mt-4",
        isWide: true,
        children: "Добавить позже"
      }),
      JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
        className: "text-center mt-10",
        children: [
          "Нет ТОО или ИП?",
          JsxRuntime.jsx("br", {}),
          "Зарегистрируем за 5 минут"
        ]
      }),
      JsxRuntime.jsx(Buhta_cabinet__Button.make, {
        kind: "default",
        type_: "button",
        className: "mt-6",
        isWide: true,
        children: "Написать Бухте"
      })
    ]
  });
}

const AddBinStage = {
  make: ObsoleteRegisterForm$AddBinStage
};

function ObsoleteRegisterForm$ConfirmInfoStage(Props) {
  let onConfirmed = Props.onConfirmed;
  const match = React.useState(function () {
    return {
      value: 1,
      text: "Индивидуальный предприниматель"
    };
  });
  const setBusinessType = match[1];
  const nameFieldRef = React.useRef(null);
  const initialFocusRef = React.useRef(null);
  return JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
    onSubmit: (function (param) {
      
    }),
    initialFocusRef: initialFocusRef,
    className: "mt-10",
    children: [
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "Введите БИН/ИИН",
        type_: "number",
        inputRef: initialFocusRef,
        value: "910114302155"
      }),
      JsxRuntime.jsx(Buhta_cabinet__Select.make, {
        className: "mt-4",
        options: {
          hd: {
            value: 1,
            text: "Индивидуальный предприниматель"
          },
          tl: {
            hd: {
              value: 2,
              text: "ТОО"
            },
            tl: {
              hd: {
                value: 3,
                text: "АО"
              },
              tl: /* [] */ 0
            }
          }
        },
        label: "Вид деятельности",
        selectedOption: match[0],
        onChange: (function (value) {
          Curry._1(setBusinessType, (function (param) {
            return value;
          }));
        }),
        nextFocusRef: nameFieldRef
      }),
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "Наименование",
        type_: "text",
        className: "mt-4",
        inputRef: nameFieldRef,
        value: "Зако.кз"
      }),
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "ФИО Руководителя",
        type_: "text",
        className: "mt-4",
        value: "Айдаш Алдияр Қамзатұлы"
      }),
      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
        label: "Юр.адрес",
        type_: "text",
        className: "mt-4",
        value: "Казахстан, Алматинская обл., г. Алма"
      }),
      JsxRuntime.jsx(Buhta_cabinet__Button.make, {
        kind: "primary",
        type_: "submit",
        className: "mt-6",
        isWide: true,
        onClick: (function (param) {
          Curry._1(onConfirmed, undefined);
        }),
        children: "Далее"
      })
    ]
  });
}

const ConfirmInfoStage = {
  make: ObsoleteRegisterForm$ConfirmInfoStage
};

function ObsoleteRegisterForm$BillingChooseStage(Props) {
  let onChosen = Props.onChosen;
  return JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
    onSubmit: (function (param) {
      
    }),
    className: "mt-10",
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
            checked: true,
            children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
              children: [
                "KZ11722C000026040773",
                JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                  className: "ml-2 text-default-gray",
                  children: "KASPI BANK"
                })
              ]
            })
          }),
          JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
            children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
              children: [
                "KZ11722C000026040773",
                JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                  className: "ml-2 text-default-gray",
                  children: "KASPI BANK"
                })
              ]
            })
          }),
          JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
            children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
              children: [
                "KZ11722C000026040773",
                JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                  className: "ml-2 text-default-gray",
                  children: "KASPI BANK"
                })
              ]
            })
          })
        ],
        className: "flex flex-col space-y-3"
      }),
      JsxRuntime.jsx(Buhta_cabinet__Button.make, {
        kind: "primary",
        type_: "submit",
        className: "mt-6",
        isWide: true,
        onClick: (function (param) {
          Curry._1(onChosen, undefined);
        }),
        children: "Подтвердить"
      })
    ]
  });
}

const BillingChooseStage = {
  make: ObsoleteRegisterForm$BillingChooseStage
};

function ObsoleteRegisterForm$OrgRegistration(Props) {
  const match = React.useState(function () {
    return /* BIN */ 0;
  });
  const setStage = match[1];
  const stage = match[0];
  const match$1 = React.useState(function () {
    
  });
  const setToast = match$1[1];
  let tmp;
  switch (stage) {
    case /* BIN */ 0 :
      tmp = JsxRuntime.jsx(Buhta_components__Text.H4.make, {
        className: "my-3 text-center animate-fadeIn duration-300",
        children: "С чем будем иметь дело? 😎"
      }, "header-1");
      break;
    case /* ConfirmForm */ 1 :
      tmp = JsxRuntime.jsx(Buhta_components__Text.H4.make, {
        className: "my-3 text-center animate-fadeIn duration-300",
        children: "Подтвердите данные 🤗"
      }, "header-2");
      break;
    case /* BillingChoose */ 2 :
      tmp = JsxRuntime.jsx(Buhta_components__Text.H4.make, {
        className: "my-3 text-center animate-fadeIn duration-300",
        children: "Укажите основной счет 🤗"
      }, "header-3");
      break;
  }
  let tmp$1;
  switch (stage) {
    case /* BIN */ 0 :
      tmp$1 = "w-1/3";
      break;
    case /* ConfirmForm */ 1 :
      tmp$1 = "w-2/3";
      break;
    case /* BillingChoose */ 2 :
      tmp$1 = "w-full";
      break;
  }
  let tmp$2;
  switch (stage) {
    case /* BIN */ 0 :
      tmp$2 = JsxRuntime.jsx(ObsoleteRegisterForm$AddBinStage, {
        onBinAdded: (function (param) {
          Curry._1(setStage, (function (param) {
            return /* ConfirmForm */ 1;
          }));
        })
      });
      break;
    case /* ConfirmForm */ 1 :
      tmp$2 = JsxRuntime.jsx(ObsoleteRegisterForm$ConfirmInfoStage, {
        onConfirmed: (function (param) {
          Curry._1(setStage, (function (param) {
            return /* BillingChoose */ 2;
          }));
        })
      });
      break;
    case /* BillingChoose */ 2 :
      tmp$2 = JsxRuntime.jsx(ObsoleteRegisterForm$BillingChooseStage, {
        onChosen: (function (param) {
          Buhta_cabinet__Route.navigateTo({
            TAG: /* Auth */ 0,
            _0: /* Login */ 0
          });
        })
      });
      break;
  }
  return JsxRuntime.jsx(Buhta_components__ToastContainer.make, {
    toast: match$1[0],
    onExpired: (function (param) {
      Curry._1(setToast, (function (param) {
        
      }));
    }),
    children: JsxRuntime.jsxs(Buhta_cabinet__Box.make, {
      className: "relative",
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            tmp,
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                className: Cn.fromList({
                  hd: "h-1 transition-width duration-300 ease-in-out  bg-primary",
                  tl: {
                    hd: tmp$1,
                    tl: /* [] */ 0
                  }
                })
              }),
              className: "h-1 w-full bg-gray-light"
            })
          ],
          className: "absolute w-full top-0 left-0"
        }),
        tmp$2
      ]
    })
  });
}

const OrgRegistration = {
  make: ObsoleteRegisterForm$OrgRegistration
};

function ObsoleteRegisterForm$WaitForActivation(Props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs(Buhta_components__Text.H4.make, {
        className: "text-center relative",
        children: [
          "Выберите предприятие",
          JsxRuntime.jsx("a", {
            children: JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/logout.svg")
            }),
            className: "absolute right-3",
            href: "/logout"
          })
        ]
      }),
      JsxRuntime.jsx("hr", {
        className: "mt-3"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/enterprise.svg")
          }),
          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: "mt-4 text-gray-medium",
            children: "Чтобы добавить компанию —"
          }),
          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
            className: "text-gray-medium",
            children: "обратитесь в поддержку"
          }),
          JsxRuntime.jsx("a", {
            children: JsxRuntime.jsx(Buhta_components__Text.H4.make, {
              className: "text-center text-white",
              children: "Связаться с Бухтой"
            }),
            className: "bg-links hover:bg-links-hover active:bg-links-active rounded-sm mt-6 w-full py-3",
            href: "mailto:hello@buhta.com"
          })
        ],
        className: "py-6 flex flex-col items-center px-10"
      })
    ],
    className: "bg-white rounded-md shadow-sm py-3"
  });
}

const WaitForActivation = {
  make: ObsoleteRegisterForm$WaitForActivation
};

export {
  secondsToTime,
  AddBinStage,
  ConfirmInfoStage,
  BillingChooseStage,
  OrgRegistration,
  WaitForActivation,
}
/* Buhta_cabinet__Box Not a pure module */
